<h2 style="text-align: -webkit-center;">{{Title | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : groupName}}
</h2>
<p>{{Text | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : groupName}}</p>
<div style="text-align: center;">
    <ng-container *ngFor="let button of InputData.Actions">
        <button mat-raised-button
            [mat-dialog-close]="button.Function">{{button.Text | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : groupName}}</button>
    </ng-container>
</div>